/** @format */

/**
 * Trace 分析 — 列表侧栏文本筛选（一行三列）。
 * 每项对应 Filters 中的一条 FilterMtchProps，由 FilterItem 渲染。
 */

import React from 'react'
import { _$ } from '@king-design/react'
import styled from 'styled-components'
import { FilterMtchProps } from './../typescript'
import { MatchMode } from 'src/pages/AIObservability/SessionAnalysis/typescript'
import { cloneDeep } from 'lodash'
import FilterItem from '../../components/FilterItem'

export const TRACE_SEARCH_OPTIONS: { label: string; key: string }[] = [
  {
    key: 'service_name',
    label: _$('服务名称')
  },
  {
    key: 'trace_id',
    label: _$('Trace ID')
  },
  {
    key: 'model_name',
    label: _$('模型名称')
  },
  {
    key: 'kind',
    label: _$('Span类型')
  },
  {
    key: 'span_kind',
    label: _$('AI Span类型')
  },
  {
    key: 'operation',
    label: _$('操作')
  },
  {
    key: 'status_code',
    label: _$('状态码')
  }
]

export interface TraceSearchProps {
  className?: string
  startTime: number
  endTime: number
  serviceName?: string
  value: FilterMtchProps[]
  onChange: (next: FilterMtchProps[]) => void
}

const TraceSearch: React.FC<TraceSearchProps> = ({
  className,
  value,
  onChange,
  startTime,
  endTime,
  serviceName
}) => {
  const handleChange = (Key: string, Op: MatchMode, Values: string[]) => {
    const newFilters = cloneDeep(value)
    const findFilter = newFilters.findIndex(item => item.Key === Key)
    if (findFilter !== -1) {
      newFilters[findFilter].Op = Op
      newFilters[findFilter].Values = Values
    } else {
      newFilters.push({
        Key,
        Op,
        Values
      })
    }
    onChange(newFilters)
  }

  return (
    <div className={className}>
      <div className="trace-search-form">
        {TRACE_SEARCH_OPTIONS?.map(item => {
          const { label, key } = item
          const findFilter = value.find(item => item.Key === key)
          const { Op, Values } = findFilter || {}
          return (
            <FilterItem
              startTime={startTime}
              endTime={endTime}
              key={key}
              fieldName={key}
              label={label}
              op={Op}
              values={Values}
              onChange={handleChange}
              isInput={key === 'trace_id'}
              filters={value}
              disabled={key === 'service_name' && !!serviceName}
            />
          )
        })}
      </div>
    </div>
  )
}

export default styled(TraceSearch)`
  .trace-search-form {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0 8px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;

    @media (max-width: 1280px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`
